import { Flex, Text, Link } from "@chakra-ui/react";
import { MdMail, MdPerson, MdPhone } from "react-icons/md";

const StoreFooter = ({ store }) => {
  const { contactInfo } = store;
  return (
    <>
      <Flex
        w="100%"
        minH="100px"
        p="20px"
        justifyContent="flex-start"
        alignItems="center"
        flexDir={"row"}
        mt="10px"
        bg="#252525"
        color={"white"}
      >
        <Flex flexDir="column" flex={1}>
          <Flex alignItems="center">
            <MdPerson /> <Text ml=".3em">{contactInfo?.name}</Text>
          </Flex>
          <Flex alignItems="center">
            <Link
              display="flex"
              justifyContent="center"
              alignItems="center"
              href={`mailto:${contactInfo?.email}`}
            >
              <MdMail /> <Text ml=".3em">{contactInfo?.email}</Text>
            </Link>
          </Flex>
          <Flex alignItems="center">
            <Link
              display="flex"
              justifyContent="center"
              alignItems="center"
              href={`tel:${contactInfo?.phone}`}
            >
              <MdPhone /> <Text ml=".3em">{contactInfo?.phone}</Text>
            </Link>
          </Flex>
        </Flex>
        <Flex
          flex={1}
          bg=""
          minH="100px"
          justifyContent="center"
          alignItems="center"
        >
        </Flex>
      </Flex>
      <Flex
        bg="black"
        w="100%"
        py="5px"
        justifyContent="center"
        alignitems="center"
      >
        <Text color="white" fontWeight="200" fontSize=".8em">
          Powered by Skyshops © {new Date().getFullYear()}
        </Text>
      </Flex>
    </>
  );
};

export default StoreFooter;
